



























































import mixins from 'vue-typed-mixins';
import { QuestionData, ReportNode, ReportStore } from '@/utils/ReportUtils';
import DashboardUtils from '@/utils/DashboardUtils';
import SurveyNodeUtils from '@/utils/SurveyNodeUtils';

interface NavigationTab {
  node: ReportNode;
  path: number[];
  url: any;
}

export default mixins().extend({
  computed: {
    store() {
      return ReportStore;
    },

    nodes(): ReportNode[] {
      return ReportStore.nodes || [];
    },

    tabs(): NavigationTab[] {
      const reducer = (result: NavigationTab[], current: ReportNode) => {
        const path = SurveyNodeUtils.generatePath(current, this.nodes);
        result.push({
          node: current,
          path: path,
          url: this.generateURL(path),
        });
        if (current.children?.length > 0) {
          current.children.reduce(reducer, result);
        }
        return result;
      };

      return this.nodes
        .reduce(reducer, [])
        ?.filter(
          (tab) => tab.node.data.visible && tab.node.type !== 'question'
        );
    },

    currentPage() {
      let path: number[] = [];
      if (this.$route.params.path) {
        path = this.$route.params.path
          .split('-')
          .map((element) => parseInt(element) - 1)
          .filter((element) => !isNaN(element));
      }

      const nodes = SurveyNodeUtils.parsePath(path, ReportStore.nodes || []);
      return nodes.find((node) => node.type === 'page') || nodes[0];
    },

    dirty(): boolean {
      return (
        this.currentPage?.children?.some(
          (node) =>
            node.type === 'question' && (node.data as QuestionData).dirty
        ) || false
      );
    },
  },

  async mounted() {
    try {
      const participation = await DashboardUtils.getCurrentSurvey();
      ReportStore.surveyParticipation = participation;
      ReportStore.survey = participation?.survey;
    } catch (error) {
      // doesn't matter if this fails
    }
  },

  methods: {
    async navigateTo(url: any) {
      const execute = async () => {
        if (ReportStore.nodes) {
          try {
            await this.$router.push(url);
          } catch (error) {
            // doesn't matter
          }
        }
      };

      if (this.dirty) {
        await this.$confirm(
          this.$i18n.t('validation.confirmation.navigation').toString(),
          execute
        );
      } else {
        await execute();
      }
    },

    generateURL(path: number[]) {
      // generate the proper URL to use depending on the values in ReportStore
      if (ReportStore.surveyParticipation) {
        return {
          name: 'survey-report',
          params: {
            participantId: ReportStore.surveyParticipation?.id,
            path: path?.join('-') || '1',
          },
        };
      } else {
        return {
          name: 'survey-edit-preview',
          params: {
            id: ReportStore.survey?.id,
            path: path?.join('-') || '1',
          },
        };
      }
    },
  },
});
